const DASHBOARD = '';
const OVERVIEW = 'overview';
const TICKET = 'ticket/:ticketId';
const CLASSES = `${DASHBOARD}/manage`;
const ADD_CLASS = `${CLASSES}/add-class`;
const MANAGE_CLASS = `${CLASSES}/:classId`;
const RESET_ALL_PASSWORDS = `${MANAGE_CLASS}/reset-passwords`;
const RESET_USER_PASSWORD = `${MANAGE_CLASS}/reset-password/:userId`;
const MANAGE_USER = `${MANAGE_CLASS}/user/:userId`;
const ADD_STUDENTS = `${MANAGE_CLASS}/add-students`;

export const routes = {
  DASHBOARD,
  OVERVIEW,
  TICKET,
  CLASSES,
  ADD_CLASS,
  MANAGE_CLASS,
  RESET_ALL_PASSWORDS,
  MANAGE_USER,
  RESET_USER_PASSWORD,
  ADD_STUDENTS,
};

export const DASHBOARD_FULL = DASHBOARD;
export const OVERVIEW_FULL = `${DASHBOARD}/${OVERVIEW}`;
export const TICKET_FULL = `${DASHBOARD}/ticket`;

export const ClASSESS_FULL = CLASSES;
export const ADD_CLASS_FULL = ADD_CLASS;
export const ADD_STUDENTS_FULL = ADD_STUDENTS;

export const getTicketRoute = (ticketId) => `ticket/${ticketId}`;
export const getManageClassRoute = (classId) => `${CLASSES}/${classId}`;
export const getResetAllRoute = (classId) => `${CLASSES}/${classId}/reset-passwords`;
export const getResetUserPasswordRoute = (classId, userId) => `${CLASSES}/${classId}/reset-password/${userId}`;
export const getManageUserRoute = (classId, userId) => `${CLASSES}/${classId}/user/${userId}`;
export const getManageStudentsRoute = (classId) => `${CLASSES}/${classId}/add-students`;
